import { Text } from "components/commons";
import { dateFormat, formatAmount, formatVolume, timeFormat } from "utils";

export const mapDataToList = ({ transactions }) => {
  const { name, transactionNumber, processedAt, cashier, sku, type, quantity, amount, remarks } =
    transactions;
  return {
    date: (
      <>
        <Text>{dateFormat(processedAt ?? "")}</Text>
        <Text>{timeFormat(processedAt ?? "", true)}</Text>
      </>
    ),
    transactionNo: <Text>{transactionNumber || "--"}</Text>,
    cashier: <Text>{cashier || "--"}</Text>,
    description: <Text>{name || "--"}</Text>,
    sku: <Text>{sku || "--"}</Text>,
    qty: <Text>{type === "fuel" ? formatVolume(quantity ?? 0) : quantity || "--"}</Text>,
    amount: <Text>{formatAmount(amount || 0)}</Text>,
    reason: <Text>{remarks || "--"}</Text>,
  };
};

export const mapFilterToRequest = (filterState) => {
  const { ...fs } = filterState;

  return {
    ...fs,
  };
};
